/* ============================================================
   SINGSPACE - TYPES PARTAGÉS (SOURCE UNIQUE DE VÉRITÉ)
   Tous les types sont définis ici, miroir du schéma Prisma.
   ============================================================ */
// ============================================================
// ENUMS (miroir exact des enums Prisma)
// ============================================================
export var UserRole;
(function (UserRole) {
    UserRole["SUPER_ADMIN"] = "SUPER_ADMIN";
    UserRole["ADMIN"] = "ADMIN";
    UserRole["MANAGER"] = "MANAGER";
})(UserRole || (UserRole = {}));
export var SpaceWorkflow;
(function (SpaceWorkflow) {
    SpaceWorkflow["IMMEDIATE"] = "IMMEDIATE";
    SpaceWorkflow["QUOTE_REQUIRED"] = "QUOTE_REQUIRED";
    SpaceWorkflow["APPLICATION_REQUIRED"] = "APPLICATION_REQUIRED";
})(SpaceWorkflow || (SpaceWorkflow = {}));
export var BookingStatus;
(function (BookingStatus) {
    BookingStatus["PENDING"] = "PENDING";
    BookingStatus["PAYMENT_PENDING"] = "PAYMENT_PENDING";
    BookingStatus["PAID"] = "PAID";
    BookingStatus["CONFIRMED"] = "CONFIRMED";
    BookingStatus["QUOTE_REQUESTED"] = "QUOTE_REQUESTED";
    BookingStatus["QUOTED"] = "QUOTED";
    BookingStatus["APPROVED"] = "APPROVED";
    BookingStatus["REJECTED"] = "REJECTED";
    BookingStatus["CANCELLED"] = "CANCELLED";
    BookingStatus["COMPLETED"] = "COMPLETED";
    BookingStatus["URGENT"] = "URGENT";
    BookingStatus["OVERDUE"] = "OVERDUE";
})(BookingStatus || (BookingStatus = {}));
export var FieldType;
(function (FieldType) {
    FieldType["TEXT"] = "TEXT";
    FieldType["NUMBER"] = "NUMBER";
    FieldType["DECIMAL"] = "DECIMAL";
    FieldType["EMAIL"] = "EMAIL";
    FieldType["PHONE"] = "PHONE";
    FieldType["SELECT"] = "SELECT";
    FieldType["MULTI_SELECT"] = "MULTI_SELECT";
    FieldType["CHECKBOX"] = "CHECKBOX";
    FieldType["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
    FieldType["RADIO"] = "RADIO";
    FieldType["FILE"] = "FILE";
    FieldType["DATE"] = "DATE";
    FieldType["TIME"] = "TIME";
    FieldType["DATETIME"] = "DATETIME";
    FieldType["TEXTAREA"] = "TEXTAREA";
    FieldType["HIDDEN"] = "HIDDEN";
    FieldType["SEPARATOR"] = "SEPARATOR";
    FieldType["HEADING"] = "HEADING";
})(FieldType || (FieldType = {}));
export var ConditionOperator;
(function (ConditionOperator) {
    ConditionOperator["EQUALS"] = "EQUALS";
    ConditionOperator["NOT_EQUALS"] = "NOT_EQUALS";
    ConditionOperator["GREATER_THAN"] = "GREATER_THAN";
    ConditionOperator["GREATER_OR_EQUAL"] = "GREATER_OR_EQUAL";
    ConditionOperator["LESS_THAN"] = "LESS_THAN";
    ConditionOperator["LESS_OR_EQUAL"] = "LESS_OR_EQUAL";
    ConditionOperator["BETWEEN"] = "BETWEEN";
    ConditionOperator["IN"] = "IN";
    ConditionOperator["NOT_IN"] = "NOT_IN";
    ConditionOperator["CONTAINS"] = "CONTAINS";
    ConditionOperator["IS_TRUE"] = "IS_TRUE";
    ConditionOperator["IS_FALSE"] = "IS_FALSE";
    ConditionOperator["IS_EMPTY"] = "IS_EMPTY";
    ConditionOperator["IS_NOT_EMPTY"] = "IS_NOT_EMPTY";
})(ConditionOperator || (ConditionOperator = {}));
export var PricingRuleType;
(function (PricingRuleType) {
    PricingRuleType["FLAT_RATE"] = "FLAT_RATE";
    PricingRuleType["PER_UNIT"] = "PER_UNIT";
    PricingRuleType["BRACKET"] = "BRACKET";
    PricingRuleType["TEMPORAL"] = "TEMPORAL";
    PricingRuleType["ADDON"] = "ADDON";
    PricingRuleType["RECURRING"] = "RECURRING";
    PricingRuleType["CONDITIONAL"] = "CONDITIONAL";
    PricingRuleType["FORMULA"] = "FORMULA";
})(PricingRuleType || (PricingRuleType = {}));
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["PENDING"] = "PENDING";
    InvoiceStatus["PAID"] = "PAID";
    InvoiceStatus["CANCELLED"] = "CANCELLED";
})(InvoiceStatus || (InvoiceStatus = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["SINGPAY"] = "SINGPAY";
    PaymentMethod["CHEQUE"] = "CHEQUE";
})(PaymentMethod || (PaymentMethod = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PENDING"] = "PENDING";
    PaymentStatus["SUCCEEDED"] = "SUCCEEDED";
    PaymentStatus["FAILED"] = "FAILED";
})(PaymentStatus || (PaymentStatus = {}));
export var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["INITIATED"] = "INITIATED";
    TransactionStatus["PENDING"] = "PENDING";
    TransactionStatus["PROCESSING"] = "PROCESSING";
    TransactionStatus["COMPLETED"] = "COMPLETED";
    TransactionStatus["FAILED"] = "FAILED";
    TransactionStatus["TIMEOUT"] = "TIMEOUT";
    TransactionStatus["CANCELLED"] = "CANCELLED";
})(TransactionStatus || (TransactionStatus = {}));
export var TransactionType;
(function (TransactionType) {
    TransactionType["COWORKING"] = "COWORKING";
    TransactionType["ROOM"] = "ROOM";
    TransactionType["OFFICE"] = "OFFICE";
})(TransactionType || (TransactionType = {}));
export var EventSource;
(function (EventSource) {
    EventSource["MANUAL"] = "MANUAL";
    EventSource["API_GOOGLE"] = "API_GOOGLE";
    EventSource["API_OUTLOOK"] = "API_OUTLOOK";
    EventSource["BOOKING"] = "BOOKING";
})(EventSource || (EventSource = {}));
export var LogLevel;
(function (LogLevel) {
    LogLevel["INFO"] = "INFO";
    LogLevel["WARN"] = "WARN";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["SUCCESS"] = "SUCCESS";
})(LogLevel || (LogLevel = {}));
// ============================================================
// FONCTIONS UTILITAIRES (conditions dynamiques)
// ============================================================
export function evaluateCondition(operator, fieldValue, expectedValue) {
    switch (operator) {
        case ConditionOperator.EQUALS:
            return String(fieldValue) === expectedValue;
        case ConditionOperator.NOT_EQUALS:
            return String(fieldValue) !== expectedValue;
        case ConditionOperator.GREATER_THAN:
            return Number(fieldValue) > Number(expectedValue);
        case ConditionOperator.GREATER_OR_EQUAL:
            return Number(fieldValue) >= Number(expectedValue);
        case ConditionOperator.LESS_THAN:
            return Number(fieldValue) < Number(expectedValue);
        case ConditionOperator.LESS_OR_EQUAL:
            return Number(fieldValue) <= Number(expectedValue);
        case ConditionOperator.BETWEEN: {
            const [min, max] = expectedValue.split(',').map(Number);
            const numValue = Number(fieldValue);
            return numValue >= min && numValue <= max;
        }
        case ConditionOperator.IN:
            return expectedValue.split(',').includes(String(fieldValue));
        case ConditionOperator.NOT_IN:
            return !expectedValue.split(',').includes(String(fieldValue));
        case ConditionOperator.CONTAINS:
            return String(fieldValue).toLowerCase().includes(expectedValue.toLowerCase());
        case ConditionOperator.IS_TRUE:
            return fieldValue === true || fieldValue === 'true';
        case ConditionOperator.IS_FALSE:
            return fieldValue === false || fieldValue === 'false';
        case ConditionOperator.IS_EMPTY:
            return !fieldValue || fieldValue === '' || (Array.isArray(fieldValue) && fieldValue.length === 0);
        case ConditionOperator.IS_NOT_EMPTY:
            return !!fieldValue && fieldValue !== '' && (!Array.isArray(fieldValue) || fieldValue.length > 0);
        default:
            return true;
    }
}
export function shouldShowField(field, formValues) {
    if (!field.dependsOnFieldKey)
        return true;
    if (!field.dependsOnOperator || field.dependsOnValue === undefined || field.dependsOnValue === null)
        return true;
    return evaluateCondition(field.dependsOnOperator, formValues[field.dependsOnFieldKey], field.dependsOnValue);
}
export function shouldShowSection(section, formValues) {
    if (!section.dependsOnFieldKey)
        return true;
    if (!section.dependsOnOperator || section.dependsOnValue === undefined || section.dependsOnValue === null)
        return true;
    return evaluateCondition(section.dependsOnOperator, formValues[section.dependsOnFieldKey], section.dependsOnValue);
}
